/* ------------------------------------------------------------------
   Bluebells Cakery — Priority Delivery card

   The $20 Priority Delivery line still does the charging (nothing
   downstream changes), but it reads as a stray product in the cart
   list. This hides that row and shows a card under the priority time
   picker instead, so the customer sees what they chose and what it
   costs in the place where they chose it.
------------------------------------------------------------------ */
(function () {
  var VARIANT = 39568791863381;
  var PRICE_LABEL = '$20.00';

  var lastGateCart = { attributes: {} };
  var lastRead = 0;

  function onCartPage() {
    return /\/cart(\/|$|\?)/.test(location.pathname + location.search);
  }

  /* One cart read shared by every Bluebells script. Both this file and the
     priority card poll the cart, and each Zapiet DOM pass used to trigger a
     fresh /cart.js - 24 of them on one load, queued behind each other, which
     is what made the widget feel slow. Requests inside the window share one
     promise; any cart mutation clears it. */
  function getCart() {
    var now = Date.now();
    var c = window.__bbCartCache;
    if (c && c.p && (now - c.t) < 600) return c.p;
    var p = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function (e) { window.__bbCartCache = null; throw e; });
    window.__bbCartCache = { t: now, p: p };
    return p;
  }
  function bustCart() { window.__bbCartCache = null; }

  /* any cart mutation - ours, the theme's or Zapiet's - invalidates the cache */
  if (!window.__bbCartHook) {
    window.__bbCartHook = 1;
    var _bbFetch = window.fetch;
    window.fetch = function (input) {
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        var isMut = /\/cart\/(add|update|change|clear)/.test(u);
        /* Zapiet's own traffic counts as "busy" too: its calendar call is the
           first thing that happens when a date is picked, and its cart writes
           follow a second or two later. Anything we read in that window lands
           in Shopify's per-session cart queue ahead of Zapiet's write and
           turns a ~400ms write into a ~1.7s one - that is the spinner. */
        if (isMut || /api\.zapiet\.com/.test(u) || /app=zapiet/.test(u)) {
          if (isMut) window.__bbCartCache = null;
          window.__bbCartLastMut = Date.now();
          /* Shopify serialises cart requests per session, so anything we read
             while the app is mid-write lands in the same queue and makes ITS
             request take seconds. Track what is in flight so our own reads
             can stay out of the way. */
          window.__bbCartBusy = (window.__bbCartBusy || 0) + 1;
          var done = function () {
            window.__bbCartBusy = Math.max(0, (window.__bbCartBusy || 1) - 1);
            window.__bbCartLastMut = Date.now();
          };
          return _bbFetch.apply(this, arguments).then(function (r) { done(); return r; },
                                                      function (e) { done(); throw e; });
        }
      } catch (e) {}
      return _bbFetch.apply(this, arguments);
    };
  }

  function priorityLine(cart) {
    return (cart.items || []).filter(function (i) {
      return Number(i.variant_id) === VARIANT;
    })[0] || null;
  }

  function chosenWindow(cart) {
    var tp = document.getElementById('time-picker');
    if (tp && tp.value) return tp.value;
    return (cart.attributes || {})['Time picker'] || '';
  }

  function deliveryDate(cart) {
    var a = cart.attributes || {};
    return nzDate(a['Delivery-Date'] || a['Pickup-Date'] || '');
  }

  /* Zapiet stores the date as YYYY/MM/DD - show it the way NZ reads it. */
  function nzDate(v) {
    var m = String(v || '').match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/);
    if (!m) return v || '';
    var pad = function (n) { return (n.length < 2 ? '0' : '') + n; };
    return pad(m[3]) + '/' + pad(m[2]) + '/' + m[1];
  }

  function money(cents) {
    try {
      return '$' + (cents / 100).toFixed(2);
    } catch (e) { return PRICE_LABEL; }
  }

  /* The cart write behind this takes a second or two and our read of the
     result waits for Zapiet to finish, so the confirmation used to land about
     five seconds after the customer picked a window. Draw it straight away
     from what is already on screen and let the real read correct it. */
  var pendingAt = 0;
  function cardHost() {
    return document.querySelector('.priority-delivery-container .container')
        || document.querySelector('.priority-delivery-container');
  }

  /* Same product shot the line would show in the cart and at checkout, so the
     card reads as the line item it stands in for. */
  var PD_IMG = 'https://cdn.shopify.com/s/files/1/0884/4436/products/deliverylogo.png?v=1634586361&width=160';
  function imgHtml() {
    return '<img class="bb-pd-img" src="' + PD_IMG + '" alt="" loading="lazy" width="56" height="56">';
  }

  function renderPending() {
    var host = cardHost();
    var cb = document.getElementById('gift-wrapping');
    var tp = document.getElementById('time-picker');
    if (!host || !cb || !cb.checked || !tp || !tp.value) return;
    var card = document.getElementById('bb-pd-card');
    if (!card) {
      card = document.createElement('div');
      card.id = 'bb-pd-card';
      card.className = 'bb-pd-card';
      host.appendChild(card);
    }
    pendingAt = Date.now();
    card.classList.add('bb-pd-card--pending');
    card.classList.remove('bb-pd-card--stale');
    var iso = document.getElementById('Zapiet-InputCalendar__deliveryDate_ISO');
    var when = [nzDate(iso && iso.value), tp.value].filter(Boolean).join(' \u00b7 ');
    card.innerHTML =
      '<div class="bb-pd-row">' +
        imgHtml() +
        '<div class="bb-pd-main">' +
          '<div class="bb-pd-title">Adding Priority Delivery<span class="bb-pd-spin"></span></div>' +
          (when ? '<div class="bb-pd-when">' + when + '</div>' : '') +
        '</div>' +
        '<div class="bb-pd-price">' + PRICE_LABEL + '</div>' +
      '</div>';
  }

  function render(cart) {
    var host = cardHost();
    if (!host) return;

    var line = priorityLine(cart);
    var card = document.getElementById('bb-pd-card');

    if (!line) {
      /* a read that lands mid-write would otherwise yank the card we just
         drew, then put it straight back - hold it for a few seconds */
      if (card && card.classList.contains('bb-pd-card--pending') &&
          Date.now() - pendingAt < 9000) return;
      if (card) card.remove();
      return;
    }

    if (!card) {
      card = document.createElement('div');
      card.id = 'bb-pd-card';
      card.className = 'bb-pd-card';
      host.appendChild(card);
    }

    card.classList.remove('bb-pd-card--pending');
    var when = [deliveryDate(cart), chosenWindow(cart)].filter(Boolean).join(' · ');
    var method = String((cart.attributes || {})['Checkout-Method'] || '').toLowerCase();
    var stale = !!method && method.indexOf('delivery') === -1;
    card.classList.toggle('bb-pd-card--stale', stale);

    card.innerHTML =
      '<div class="bb-pd-row">' +
        imgHtml() +
        '<div class="bb-pd-main">' +
          '<div class="bb-pd-title">' + (stale ? 'Priority Delivery — not available with this delivery method' : 'Priority Delivery added') + '</div>' +
          (when ? '<div class="bb-pd-when">' + when + '</div>' : '') +
          '<button type="button" class="bb-pd-remove" data-bb-pd="remove">Remove</button>' +
        '</div>' +
        '<div class="bb-pd-price">' + money(line.final_line_price) + '</div>' +
      '</div>';
  }

  /* Shopify queues cart requests per session, so a read of ours landing while
     Zapiet is saving pushes its write from ~400ms to ~1.7s - that is the
     spinner. Wait the burst out rather than dropping the read. */
  var refreshWait = null;
  function appBusy() {
    return (window.__bbCartBusy || 0) > 0 ||
           (Date.now() - (window.__bbCartLastMut || 0) < 3000);
  }
  function refresh() {
    if (!onCartPage()) return;
    if (appBusy()) {
      clearTimeout(refreshWait);
      refreshWait = setTimeout(refresh, 700);
      return;
    }
    getCart().then(function (cart) {
      lastRead = Date.now();
      lastGateCart = cart;
      render(cart);
    }).catch(function () {});
  }

  /* On load, make the checkbox agree with the cart. The attribute alone can't
     be trusted: Zapiet rewrites it to "No" when priority is turned off, and
     Liquid treats any non-empty value as checked - so the box could come back
     ticked with nothing in the cart. The $20 line is the truth. */
  function syncControl() {
    if (!onCartPage()) return;
    getCart().then(function (cart) {
      var cb = document.getElementById('gift-wrapping');
      var tpc = document.querySelector('.time-picker-container');
      var tp = document.getElementById('time-picker');
      if (!cb) return;
      var on = !!priorityLine(cart);
      cb.checked = on;
      if (tpc) tpc.classList.toggle('hide', !on);
      if (tp && !on) tp.value = '';
      if (tp && on) {
        var want = (cart.attributes || {})['Time picker'] || '';
        if (want) tp.value = want;
      }
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-bb-pd="remove"]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    b.textContent = 'Removing…';
    var done = function () { location.reload(); };
    try {
      var cb = document.getElementById('gift-wrapping');
      if (cb) cb.checked = false;
      var tp = document.getElementById('time-picker');
      if (tp) tp.value = '';
      var tpc = document.querySelector('.time-picker-container');
      if (tpc) tpc.classList.add('hide');
      if (window.Shopify && Shopify.Cart && Shopify.Cart.GiftWrap) {
        Promise.resolve(Shopify.Cart.GiftWrap.remove()).then(done, done);
        setTimeout(done, 2500);
        return;
      }
    } catch (err) {}
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Postmut-Guard': '1' },
      body: JSON.stringify({ updates: { '39568791863381': 0 }, attributes: { 'Priority-Delivery': '', 'Time picker': '' } })
    }).then(done, done);
  });


  /* ---------- keeping the control honest ---------- */

  /* Zapiet's Checkout-Method attribute lags behind the widget - it can still
     read "delivery" while the customer is looking at the Pickup tab. The
     highlighted tab is what they actually see, so trust that first. */
  function isDelivery(cart) {
    var tabs = document.querySelectorAll('.checkoutMethod');
    if (tabs.length) {
      var active = [].filter.call(tabs, function (t) { return t.classList.contains('active'); })[0];
      if (active) return /delivery/i.test(active.innerText || '');
    }
    return String((cart.attributes || {})['Checkout-Method'] || '').toLowerCase().indexOf('delivery') !== -1;
  }

  function setTotal(cents) {
    var el = document.querySelector('.totals__total-value');
    if (el) el.textContent = money(cents);
  }

  var removing = false;

  /* Take the $20 off without a page reload - a reload here would throw away
     the address the customer just entered in the Zapiet widget. */
  function dropPriority() {
    if (removing) return Promise.resolve();
    removing = true;
    var cb = document.getElementById('gift-wrapping');
    var tp = document.getElementById('time-picker');
    var tpc = document.querySelector('.time-picker-container');
    if (cb) cb.checked = false;
    if (tp) tp.value = '';
    if (tpc) tpc.classList.add('hide');
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Postmut-Guard': '1' },
      body: JSON.stringify({ updates: { '39568791863381': 0 }, attributes: { 'Priority-Delivery': '', 'Time picker': '' } })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      window.__BB_PENDING_REMOVE_PRIORITY = false;
      setTotal(cart.total_price);
      render(cart);
    }).catch(function () {}).then(function () { removing = false; });
  }

  /* The charge only survives once Zapiet has confirmed a delivery address, so
     don't let it be ticked before then - it used to be added and then silently
     stripped, leaving the cart saying "priority" with nothing charged. */
  /* Priority is only meaningful once Zapiet knows the day it is delivering,
     because the priority window list is built from that day's slots. */
  function hasDate() {
    var iso = document.getElementById('Zapiet-InputCalendar__deliveryDate_ISO');
    if (iso && String(iso.value || '').trim()) return true;
    var vis = document.getElementById('Zapiet-InputCalendar__delivery');
    return !!(vis && String(vis.value || '').trim());
  }

  /* Until Zapiet has both a delivery method and a date, the whole priority
     block is hidden rather than greyed - a disabled tick with an explanation
     underneath was just noise in a panel the customer is still filling in. */
  function gate(cart) {
    var cb = document.getElementById('gift-wrapping');
    if (!cb) return;
    var ok = isDelivery(cart) && hasDate();
    cb.disabled = !ok;
    var label = cb.parentElement;
    if (label) label.classList.remove('bb-pd-disabled');
    var block = (label && label.closest && label.closest('.priority-delivery-container')) || label;
    if (block) block.classList.toggle('bb-pd-hidden', !ok);
    var hint = document.getElementById('bb-pd-hint');
    if (hint) hint.remove();
  }

  var reconcileWait = null;
  function reconcile() {
    if (!onCartPage()) return;
    if (appBusy()) {
      clearTimeout(reconcileWait);
      reconcileWait = setTimeout(reconcile, 700);
      return;
    }
    getCart().then(function (cart) {
      lastGateCart = cart;
      lastRead = Date.now();
      gate(cart);
      if (priorityLine(cart) && !isDelivery(cart)) return dropPriority();
      render(cart);
    }).catch(function () {});
  }

  /* Switching method: drop it straight away rather than leaving an inflated
     total that only corrects itself when they press checkout. */
  document.addEventListener('click', function (e) {
    var m = e.target && e.target.closest && e.target.closest('.checkoutMethod');
    if (!m) return;
    var wantsDelivery = /delivery/i.test(m.innerText || '');
    setTimeout(function () {
      if (wantsDelivery) { reconcile(); return; }
      getCart().then(function (cart) {
        gate(cart);
        if (priorityLine(cart)) dropPriority();
      }).catch(function () {});
    }, 1200);
  }, true);

  function watch() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        /* Zapiet rewrites this footer several times a second. Re-reading the
           cart on every pass put a /cart.js in front of Zapiet's own writes -
           Shopify queues cart requests per session, so that is what stretched
           its save to seconds and left the spinner up. Re-check what is on
           screen (free), and only go back to the server when the cart has
           actually changed or the reading is stale. */
        gateTick();
        if (appBusy()) return;
        if (!window.__bbCartCache || Date.now() - lastRead > 10000) refresh();
      }, 400);
    }).observe(footer, { childList: true, subtree: true });
  }

  function listenToZapiet() {
    var tries = 0;
    (function attempt() {
      if (window.ZapietEvent && typeof ZapietEvent.listen === 'function') {
        try {
          ZapietEvent.listen('selected_method', function () { setTimeout(reconcile, 1200); });
          ZapietEvent.listen('widget_loaded', function () { setTimeout(reconcile, 800); });
        } catch (e) {}
        return;
      }
      if (++tries < 25) setTimeout(attempt, 400);
    }());
  }

  /* The checkbox is enabled purely from what is on screen (method tab + date),
     so it can be re-checked on a cheap DOM-only tick. Zapiet fills the date in
     without firing an event we can rely on, and this costs no requests. */
  function gateTick() {
    if (!onCartPage()) return;
    try { gate(lastGateCart); } catch (e) {}
  }

  function boot() {
    if (!onCartPage()) return;
    refresh();
    syncControl();
    setInterval(gateTick, 700);
    setTimeout(reconcile, 2500);
    setTimeout(function () { refresh(); syncControl(); }, 1500);
    setTimeout(refresh, 3000);
    watch();
    listenToZapiet();
    document.addEventListener('change', function (e) {
      if (e.target && /^Zapiet-InputCalendar__delivery/.test(e.target.id || '')) {
        setTimeout(reconcile, 600);
        setTimeout(reconcile, 2000);
      }
      if (e.target && (e.target.id === 'time-picker' || e.target.id === 'gift-wrapping')) {
        renderPending();
        setTimeout(refresh, 2000);
        setTimeout(refresh, 5000);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
